export default "__VITE_ASSET__91545d43__"